// Class: openfl.display._internal.AssetManifestLoader

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $hxEnums = require("./../../../hxEnums_stub").default;
var $import = require("./../../../import_stub").default;
var $bind = require("./../../../bind_stub").default;
function openfl_display_IDisplayObjectLoader() {return require("./../../../openfl/display/IDisplayObjectLoader");}
function lime_app_Promise() {return require("./../../../lime/app/Promise");}
function openfl_net_URLLoader() {return require("./../../../openfl/net/URLLoader");}
function lime_utils_AssetManifest() {return require("./../../../lime/utils/AssetManifest");}
function haxe_io_Path() {return require("./../../../haxe/io/Path");}
function lime_utils_AssetLibrary() {return require("./../../../lime/utils/AssetLibrary");}
function openfl_utils_AssetLibrary() {return require("./../../../openfl/utils/AssetLibrary");}
function openfl_utils_Assets() {return require("./../../../openfl/utils/Assets");}
function Std() {return require("./../../../Std");}

// Constructor

var AssetManifestLoader = function() {
}

// Meta

AssetManifestLoader.__name__ = "openfl.display._internal.AssetManifestLoader";
AssetManifestLoader.__isInterface__ = false;
AssetManifestLoader.__interfaces__ = [(openfl_display_IDisplayObjectLoader().default)];
AssetManifestLoader.prototype = {
	load: function(request,context,contentLoaderInfo) {
		if(contentLoaderInfo.contentType != null && contentLoaderInfo.contentType.indexOf("/json") > -1) {
			var promise = new (lime_app_Promise().default)();
			var loader = new (openfl_net_URLLoader().default)();
			loader.dataFormat = "text";
			loader.addEventListener("complete",function(event) {
				var path = request.url;
				var queryIndex = path.indexOf("?");
				if(queryIndex > -1) {
					path = path.substring(0,queryIndex);
				}
				var manifest = (lime_utils_AssetManifest().default).parse(loader.data,(haxe_io_Path().default).directory(path));
				if(manifest == null) {
					promise.error("Cannot parse asset manifest");
					return;
				}
				var library = (lime_utils_AssetLibrary().default).fromManifest(manifest);
				if(library == null) {
					promise.error("Cannot open library");
					return;
				}
				if(((library) instanceof (openfl_utils_AssetLibrary().default))) {
					library.load().onComplete(function(_) {
						var library1 = library;
						contentLoaderInfo.assetLibrary = library1;
						(openfl_utils_Assets().default).registerLibrary(contentLoaderInfo.url,library1);
						if(manifest.name != null && !(openfl_utils_Assets().default).hasLibrary(manifest.name)) {
							(openfl_utils_Assets().default).registerLibrary(manifest.name,library1);
						}
						var clip = library1.getMovieClip("");
						promise.complete(clip);
					}).onProgress($bind(promise,promise.progress)).onError($bind(promise,promise.error));
				} else {
					promise.error("Library is not an OpenFL AssetLibrary");
				}
			});
			loader.addEventListener("ioError",function(event1) {
				promise.error(event1);
			});
			loader.addEventListener("progress",function(event2) {
				var tmp = (Std().default).int(event2.bytesLoaded);
				var tmp1 = (Std().default).int(event2.bytesTotal);
				promise.progress(tmp,tmp1);
			});
			loader.load(request);
			return promise.future;
		} else {
			return null;
		}
	},
	loadBytes: function(buffer,context,contentLoaderInfo) {
		return null;
	}
};
AssetManifestLoader.prototype.__class__ = AssetManifestLoader.prototype.constructor = $hxClasses["openfl.display._internal.AssetManifestLoader"] = AssetManifestLoader;

// Init



// Statics




// Export

exports.default = AssetManifestLoader;